namespace Portico.Services {
    import Inject = Portico.Decorators.Inject;
    import Service = Portico.Decorators.Service;

    import ps = Portico.Services;
    import pme = Portico.Models.Enterprise;
	import psga = apigateway.client;
	import psgm = apigateway.models;

    export interface IPatientAccountService {
		getAccount(): angular.IPromise<pme.Account>;
        getActiveEnrollments(): angular.IPromise<psgm.EnrollmentModel[]>;
		getCase(caseId: number): angular.IPromise<psgm.GetCaseResponseModel>;
		isPatientRegistered(patientAccountRegistration: pme.PatientAccountRegistration): angular.IPromise<psgm.IPatientRegistrationData>;
        patientRegistration(patientAccountRegistration: pme.PatientAccountRegistration): angular.IPromise<psgm.IPatientRegistrationData>;
    }

    @Service('app', 'patientAccountService')
    @Inject('$q', 'EdgePatientAccountApi')
    export class PatientAccountService implements IPatientAccountService {
        constructor(
			private $q: angular.IQService,
            private edgePatientAccountApi: psga.EdgePatientAccountApi
        ){}

		getAccount() {
			return this.$q.when(this.edgePatientAccountApi.patientAccountGetPatientAccount().then(response => {
				response.data.data.account.lastModifiedTime = <moment.Moment><unknown>response.data.data.account.lastModifiedTime?.toDate();
				response.data.data.patient.dateOfBirth = <moment.Moment><unknown>response.data.data.patient.dateOfBirth?.toDate();
				const account = new pme.Account(response.data.data.account);
				account.patient = new pme.Patient(response.data.data.patient);
				return account;
			}));
		}

        getActiveEnrollments() {
			return this.$q.when(this.edgePatientAccountApi.patientAccountGetPatientActiveEnrollments().then(response => {
				response.data.data.forEach(e => {
					e.claimEligibilityDate = <moment.Moment><unknown>e.claimEligibilityDate?.toDate();
					e.createdOn = <moment.Moment><unknown>e.createdOn?.toDate();
					e.endDate = <moment.Moment><unknown>e.endDate?.toDate();
					e.reenrollmentEligibilityDate = <moment.Moment><unknown>e.reenrollmentEligibilityDate?.toDate();
					e.startDate = <moment.Moment><unknown>e.startDate?.toDate();
					e.updatedOn = <moment.Moment><unknown>e.updatedOn?.toDate();
				});
				return response.data.data;
			}));
        }

		getCase(caseId: number) {
			const request: psgm.GetCaseRequestModel = {
				caseId: caseId,
				includeDiagnoses: true,
				includePayors: true,
				includePharmacies: true,
				includePrescribers: true,
				includePrescriptions: true,
				includeSites: true,
				includeSurveys: true
			};

			return this.$q.when(this.edgePatientAccountApi.patientAccountGetCase(request).then(response => {
				response.data.data.accountData.lastModifiedTime = <moment.Moment><unknown>response.data.data.accountData.lastModifiedTime?.toDate();
				response.data.data.caseData.createdOn = <moment.Moment><unknown>response.data.data.caseData.createdOn?.toDate();
				response.data.data.caseData.endDate = <moment.Moment><unknown>response.data.data.caseData.endDate?.toDate();
				response.data.data.caseData.expirationDate = <moment.Moment><unknown>response.data.data.caseData.expirationDate?.toDate();
				response.data.data.caseData.startDate = <moment.Moment><unknown>response.data.data.caseData.startDate?.toDate();
				response.data.data.patientData.dateOfBirth = <moment.Moment><unknown>response.data.data.patientData.dateOfBirth?.toDate();
				response.data.data.payorData.forEach(p => {
					p.benefitData.createDate = <moment.Moment><unknown>p.benefitData.createDate?.toDate();
					p.benefitData.dateOfBirth = <moment.Moment><unknown>p.benefitData.dateOfBirth?.toDate();
					p.benefitData.planEffectiveDate = <moment.Moment><unknown>p.benefitData.planEffectiveDate?.toDate();
					p.benefitData.planExpirationDate = <moment.Moment><unknown>p.benefitData.planExpirationDate?.toDate();
					p.benefitData.planTerminationDate = <moment.Moment><unknown>p.benefitData.planTerminationDate?.toDate();
				});
				response.data.data.prescriptionData.forEach(p => {
					p.createdOn = <moment.Moment><unknown>p.createdOn?.toDate();
					p.updatedOn = <moment.Moment><unknown>p.updatedOn?.toDate();
					p.writtenOn = <moment.Moment><unknown>p.writtenOn?.toDate();
				});
				response.data.data.siteData.forEach(s => {
					s.siteData.businessEndTime = <moment.Moment><unknown>s.siteData.businessEndTime?.toDate();
					s.siteData.businessStartTime = <moment.Moment><unknown>s.siteData.businessStartTime?.toDate();
				});
				response.data.data.surveyData.forEach(s => {
					s.sessionData.creationTime = <moment.Moment><unknown>s.sessionData.creationTime?.toDate();
				});
				return response.data.data;
			}));
		}

		isPatientRegistered(patientAccountRegistration: pme.PatientAccountRegistration) {
			const registration = new pme.PatientAccountRegistration(patientAccountRegistration);
			const request: psgm.IIsPatientRegisteredRequestModel = {
				firstName: registration.firstName,
				lastName: registration.lastName,
				dob: moment(registration.dob),
				gender: registration.gender,
				zip: registration.zip,
			}

			return this.$q.when(this.edgePatientAccountApi.patientAccountIsPatientRegistered(request).then(response => {
				return response.data.data;
			}));
		}

		patientRegistration(patientAccountRegistration: pme.PatientAccountRegistration) {
			const registration = new pme.PatientAccountRegistration(patientAccountRegistration);
			const request: psgm.IPatientRegistrationRequestModel = {
				userName: registration.userName,
				password: registration.password,
				firstName: registration.firstName,
				lastName: registration.lastName,
				dob: moment(registration.dob),
				gender: registration.gender,
				zip: registration.zip,
				phone: registration.phone,
				fax: registration.fax,
				email: registration.email,
				sendEmail: registration.sendEmail,
				externalId: null
			}

			return this.$q.when(this.edgePatientAccountApi.patientAccountPatientRegistration(request).then(response => {
				return response.data.data;
			}));
		}
    }
}